import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from '../../../core/panels/dialog.component';
import { ButtonComponent } from '../../../core/buttons/button.component';
import { ProgressbarComponent } from '../../../core/labels/progressbar.component';

/**
 * Shared modal component for EOR reprint processing
 * Displays loading state, error state, or success state
 */
@Component({
  selector: 'app-eor-reprint-modal',
  standalone: true,
  imports: [
    CommonModule,
    DialogComponent,
    ButtonComponent,
    ProgressbarComponent,
  ],
  template: `
    <app-dialog
      [label]="
        error ? 'EOR Request Failed' : 'Processing Your Document Request'
      "
      [visible]="visible"
      [closable]="!loading"
      width="35rem"
    >
      <ng-template #content>
        @if (loading) {
          <!-- Loading State -->
          <div class="tw-flex tw-flex-col tw-items-center tw-py-6">
            <p class="tw-text-center tw-mb-6 tw-text-base">
              Please wait while your request is processed.<br />
              The more EORs requested the longer the wait will be.
            </p>
            <app-progressbar />
          </div>
        } @else if (error) {
          <!-- Error State -->
          <div class="tw-flex tw-flex-col tw-items-center tw-py-6">
            <div class="tw-mb-6 tw-text-center">
              <i
                class="pi pi-exclamation-circle tw-text-red-500 tw-text-6xl tw-mb-4"
              ></i>
              <p class="tw-text-base tw-text-gray-700">
                {{ error }}
              </p>
            </div>
            <app-button emphasis="High" label="Close" (click)="onClose()" />
          </div>
        }
      </ng-template>
    </app-dialog>
  `,
  styles: ``,
})
export class EorReprintModalComponent {
  @Input() visible = false;
  @Input() loading = false;
  @Input() error: string | null = null;

  @Output() close = new EventEmitter<void>();

  onClose(): void {
    this.close.emit();
  }
}
